// ** Icons Import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcode, faCalendarDay, faCalendarDays, faCalendarTimes, faGear, faIdCard, faUser } from '@fortawesome/free-solid-svg-icons'

const wMenu = (user) => {
   const menu = [
    {
      header: 'Apps'
    }
  ]
  if (user) {
    if (user === 'admin' || user === 'lector') {
      menu.push({
      id: 'registro',
      title: 'Registro',
      icon: <FontAwesomeIcon icon={faBarcode} size='3x' />,
      navLink: '/apps/registro'
     })   
    }
 
  if (user === 'admin' || user === 'editor') {
    menu.push({
    id: 'setting',
    title: 'Settings',
    icon: <FontAwesomeIcon icon={faGear} size='3x' />,
    children: [
      {
        id: 'colaborador',
        title: 'Enrolamiento',
        icon: <FontAwesomeIcon icon={faIdCard} size='3x' />,
        navLink: '/apps/colaborador/list'
      },
      {
        id: 'range',
        title: 'Tramos',
        icon: <FontAwesomeIcon icon={faCalendarTimes} size='3x' />,
        navLink: '/apps/range/list'
      },
      {
        id: 'usuarios',
        title: 'Usuarios',
        icon:<FontAwesomeIcon icon={faUser} size='3x' />,
        navLink: '/apps/user/list'
      }
    ]
  })
  
  }
    
  
}
return menu
}


export default wMenu